module.exports = __webpack_public_path__ + "static/media/seilbahn~bdQsICwB.77049921.svg";